__turbopack_context__.v({
  "adornment": "TextInput-module__ES7MOG__adornment",
  "disabled": "TextInput-module__ES7MOG__disabled",
  "lc-text-input": "TextInput-module__ES7MOG__lc-text-input",
  "styled": "TextInput-module__ES7MOG__styled",
});
